import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { toast } from "@pos/ui";
import {
  initRendererSentry,
  SentryErrorBoundary,
} from "@pos/shared/observability";
import { App } from "./App";
import "./index.css";

initRendererSentry({
  dsn: import.meta.env.VITE_SENTRY_DSN ?? "",
  environment: import.meta.env.VITE_APP_ENV ?? "development",
  release: __APP_VERSION__,
});

window.addEventListener("unhandledrejection", (event) => {
  const reason = event.reason;
  const message =
    reason instanceof Error ? reason.message : String(reason ?? "Unknown");
  console.error("[unhandledrejection]", reason);
  if (reason instanceof Error && reason.stack) {
    console.error(reason.stack);
  }
  toast.error(`Unhandled error: ${message}`);
});

window.addEventListener("error", (event) => {
  console.error("[window.error]", event.error ?? event.message);
  if (event.error instanceof Error && event.error.stack) {
    console.error(event.error.stack);
  }
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <SentryErrorBoundary
      fallback={({ error, resetError }) => (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center">
          <h1 className="text-lg font-semibold">Something went wrong</h1>
          <p className="max-w-md text-sm text-muted-foreground">
            {error instanceof Error ? error.message : "Unknown error"}
          </p>
          <button
            type="button"
            onClick={resetError}
            className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
          >
            Try again
          </button>
        </div>
      )}
    >
      <App />
    </SentryErrorBoundary>
  </StrictMode>,
);
